module.exports = __webpack_public_path__ + "img/delano_0.97f49838.jpg";